// extracted by mini-css-extract-plugin
module.exports = {"faq":"_1Uy04"};